import type {
  DiamModifierValues,
  DiamTeamRoleUpdateRequest,
} from '../../diamApi';
import { mapCreateRoleInclusions } from '../CreateRoleDrawer/mapCreateRoleInclusions';
import type { DiamRoleDetails } from '../../diamApi';
import type { RoleDetailsFormValues } from './types';

function mapFormModifiersToApi(
  modifiers: RoleDetailsFormValues['modifiers'],
): DiamModifierValues {
  const values: DiamModifierValues = {};
  for (const modifier of modifiers) {
    if (modifier.value.trim()) {
      values[modifier.id] = modifier.value.trim();
    }
  }
  return values;
}

export function mapRoleDetailsToUpdateRequest(
  values: RoleDetailsFormValues,
  functionalRoles: readonly DiamRoleDetails[],
): DiamTeamRoleUpdateRequest {
  const inclusions = mapCreateRoleInclusions(
    values.selectedPermissionIds,
    functionalRoles,
  );

  if (inclusions.length === 0) {
    throw new Error('Select at least one role or attribute');
  }

  return {
    name: values.name.trim(),
    description: values.description.trim() || undefined,
    inclusions,
    modifiers: mapFormModifiersToApi(values.modifiers),
  };
}
